<template>
  <div 
    class="reward-card" 
    :class="{
      'reward-card_rating': type === 'rating',
      'reward-card_compact': compactMobile,
    }"
    @click.stop="onClick"
  >
    <div class="reward-card__cover-container">
      <div class="reward-card__cover" :style="{'background-image': `url(${image || defaultCover})`}"></div>    
    </div>
    <div class="reward-card__info">
      <div class="info__title" v-html="title"></div>
      <div class="info__subtitle" v-html="subtitle"></div>
      <div class="info__placeholder"></div>
      <div class="info__additional">
        <div class="info__value">
          <div class="info__value-icon">
            <img :src="valueIcon"/>
          </div>
          <div class="info__value-points" v-html="formatValue(cost)"></div>
        </div>
        <div v-if="state !== ''" class="info__state" :class="stateClass">
          <span v-html="stateLabels ? (stateLabels[state] || '') : ''"></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Coin from '../assets/img/coin.svg';
import Point from '../assets/img/point.svg';
import Cover from '../assets/img/cover.png';

export default {
  name: 'RewardCard',
  designVersion: '1.0.0',
  props: {
    /**
     * Ссылка на верхнее изображение
     */
    image: {
      type: String,
    },
    /**
     * Действие по нажатию мышью на карточку<br>
     * `{ func: someFunction() { ... } }` вызвать функцию someFunction<br>
     * `{ link: '/some/link' }` перейти по ссылке '/some/link'
     */
    action: {
      type: Object,
    },
    /**
     * Тип карточки<br>
     * `'rating'` с очками рейтинга<br>
     * `'coins'` с баллами-монетами
     */
    type: {
      type: String,
      default: 'rating',
      validator(value) {
        return ['', 'rating', 'coins'].indexOf(value) !== -1;
      },
    },
    /**
     * Состояние этого поощрения<br>
     * `'available'` в наличии<br>
     * `'count'` количество ограничено N шт.
     */
    state: {
      type: String,
      validator(value) {
        return ['', 'available', 'count'].indexOf(value) !== -1;
      },
    },
    /**
     * Названия для состояний задания<br>
     * `{ available: 'В наличии', count: '5 шт.' }`
     */
    stateLabels: {
      type: Object,
    },
    /**
     * Текст заголовка
     */
    title: {
      type: String,
    },
    /**
     * Текст подзаголовка
     */
    subtitle: {
      type: String,
    },
    /**
     * Цена поощрения (очки/монеты)
     */
    cost: {
      type: [String, Number],
    },
    /**
     * Использовать компактный вариант мобильной верстки
     */
    compactMobile: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      defaultCover: Cover,
      coinImage: Coin,
      pointImage: Point,
    };
  },
  computed: {
    stateClass() {
      return `info__state_${this.state}`;
    },
    valueIcon() {
      if (this.type === 'rating') return this.pointImage;
      else if (this.type === 'coins') return this.coinImage;
      else return '';
    },
  },
  methods: {
    onClick() {
      if (!this.action) return;
      if (this.action.link) {
        location.href = this.action.link;
        return;
      }
      if (this.action.func && typeof this.action.func === 'function') {
        this.action.func();
      }
    },
    formatValue(value) {
      if (value >= 10000) return (value / 1000).toFixed(0) + 'k';
      else if (value >= 1000) {
        value = value.toString();
        return value.slice(0, 1) + '&#8239;' + value.slice(1);
      }
      return value;
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "./RewardCard";
</style>
